export const trading = {
    等待确认: '等待确认',
    gas矿工费: 'gas矿工费',
    审核扫描: '审核扫描',
    警报: '警报',
    无警报: '无警报',
    显示更多: '显示更多',
    infos: "这些审计结果是自动的，由 Biking 外部的实体执行，它们不是建议，应与其他因素一起考虑。 Biking不会验证也不对通过这些外部审计员获得的数据的质量负责，请始终进行自己的研究并咨询多个信息源。",

    请输数量: '请输数量',
    兑换: '兑 换',
    价格: '价格',
    选择代币: '选择代币',
    搜索名称或粘贴地址: '搜索名称或粘贴地址',
    DEXT分数: 'DEXT分数',
    更多检测: '更多检测',
    检查审核: '检查审核',
    令牌描述: '令牌描述',
    更新: '更新',
    合同验证: '合同验证',
    买入税: '买入税',
    代理合同: '代理合同',
    可造币: '可造币',
    可修改税收: '可修改税收',
    转让可暂停: '转让可暂停',
    黑名单: '黑名单',
    找回所有权: '找回所有权',
    可修改余额: '可修改余额',
    隐藏的所有者: '隐藏的所有者',
    自毁: '自毁',
    外部呼叫风险: '外部呼叫风险',
    可以购买: '可以购买',
    最大卖出比率: '最大卖出比率',
    白名单: '白名单',
    反鲸鱼可修改: '反鲸鱼可修改',
    交易冷却时间: '交易冷却时间',
    可修改的个人税收: '可修改的个人税收',
    真的假的代币: '真的/假的代币',
    空投骗局: '空投骗局',
    可以信任: '可以信任',
    业主地址: '业主地址',
    所有者余额: '所有者余额',
    业主百分比: '业主百分比',
    创建者地址: '创建者地址',
    创造者余额: '创造者余额',
    创造者百分比: '创造者百分比',
    配对持有者: '配对持有者',
    其他风险: '其他风险',
    注意: '注意',
    交易: '交易',
    dex委托: 'swap委托',
    dex历史委托: 'swap历史委托',
  kpsj: "开盘时间",
  jlks: "距离开始",
  t: "天",
  s: "时",
  f: "分",
  m: "秒",

    zgj: '最高价：',
    zdj: '最低价：',
    gflj: '官方链接',
    gw: '官网',
    qkllq: '区块浏览器',
    scfxsj: '首次发行时间',
    fxzl: '发行总量',
    ltzl: '流通总量',
    jy: '交易',
    sj: '市价',
    tbxx: '图表信息',
    bzgk: '币种概况',
    jcb: '基础版',
    ddb: '订单表',
    zxcj: '最新成交',
  
    reload: "刷新",
    socketError: "网络错误，请",
    noData: "暂无数据",
    entrustorder: "盘口",
    prices: "价格",
    quantity: "数量",
    grandtotal: "累计",
    transamount: "交易额",
    time: "时间",
    available: "可用",
    limitorder: "限价",
    plancommission: "计划委托",
    currentcommission: "委托",
    historycommission: "历史委托",
    completecommission: "成交委托",
    funds: '资金',
    hidetrading: "隐藏其他交易对",
    morecurrentcommission: "更多当前委托",
    morehistorycommission: "更多历史委托",
    moredocommission: "更多成交委托",
    realtimetrans: "实时成交",
    myassets: "我的资产",
    detail: "详情",
    buyin: "买入",
    sellout: "卖出",
    login: "登录",
    transfer: "划转",
    recharge: "充值",
    withdrawal: "买币",
    quickpurchase: "法币快捷买币",
    default: "默认",
    ordertime: "挂单时间",
    windingtime: "上链时间",
    tradingpair: "交易对",
    direction: "方向",
    types: "类型",
    commissionprice: "委托价格",
    commissionnumber: "委托数量",
    dealprice: "成交均价",
    dealnumber: "成交数量",
    triggerprice: "触发价格",
    cancelall: "全部撤单",
    averageprice: "均价",
    totalsum: "合计",
    fixedprice: "限价",
    marketprice: "市价",
    codeExpired: "二维码已失效",
    clickRefresh: "点击刷新",
    QRsuccessfully: "扫码成功",
    loginInApp: "请在APP内确认登录",
    backtoQR: "返回二维码登录",
    loginSuccess: "您已登录成功，biking欢迎您！",
    loadingText: "加载中...",
    searchPlaceholder: "搜索",
    all: "全部",
    currency: "币种",
    price: "最新价",
    market: "涨幅榜",
    increase: "涨幅",
    highestPrice: "最高",
    minimumPrice: "最低",
    turnover: "成交量",
    jydlb: "交易对列表",
    bzjs: "币种介绍",
    currencyTransaction: "币币交易",
    leveragedTransaction: "杠杆交易",
    warning:
      "风险提示： Bitcoin Cash分叉具有极大的不确定性，交易或者投资分叉期货代币具有极大的风险，如果某一条链缺乏矿工的支持，很可能无法存续，持有的相关代币将有归零风险。BiKing不为任何分叉期货代币的价值作出任何承诺！",
    zb: "指标",
    date: "时间",
    UpAnddown: "涨跌",
    amplitude: "振幅",
    0: "分时",
    1: "1分钟",
    5: "5分钟",
    15: "15分钟",
    30: "30分钟",
    60: "1小时",
    240: "4小时",
    3600: "1天",
    10800: "1周",
    dates: "周期：",
    password: "交易密码",
    errorPassword: "请输入正确交易密码",
    worningPassword: "请输入交易密码",
    cancel: "取消",
    sure: "确定",
    canBuy: "可买",
    canCell: "可卖",
    withdraw: "提币",
    otc: "OTC，法币快速入场提现",
    enterPrice: "请输入价格",
    sellingPrice: "卖出价",
    purchasePrice: "买入价",
    salesVolume: "卖出量",
    buyingVolume: "买入量",
    volume: "交易额",
    serviceCharge: "手续费",
    vip: "升级VIP 手续费立享折扣",
    or: "或",
    register: "注册",
    totalPrice: "交易额不能大于",
    amountTip: "请输入正确数量",
    amountTipError: "数量不能大于",
    limitTrading: "限价交易",
    priceReminder: "价格提醒",
    SMSReminder: "短信提醒",
    loginAccount: "登录账户",
    phone: "手机",
    phoneNum: "请输入手机号码",
    phoneTips: "请输入正确手机号码",
    email: "邮箱",
    emailNum: "请输入邮箱",
    emailTips: "﻿请输入正确邮箱",
    aears: "请选择区号",
    passwordError: "请输入正确密码",
    passwordTips: "请输入密码",
    forgetPassword: "忘记密码",
    noAccount: "没有账号",
    goRegister: "立即注册",
    appsys: "APP扫一扫安全登录",
    xzapp: "下载最新APP",
    mmdl: "密码登陆",
    smdl: "扫码登陆",
    google: "谷歌验证器",
    nybd: "您已绑定",
    zqyzm: "请输入正确验证码",
    fsyzm: "发送验证码",
    flv: "费率",
    jz: "净值",
    jzdesc1:
      "看多净值=上个调整时点的净值*[1+3*(现货最新成交价-现货上个调整时点价格)/现货上个调整时点价格*100%]；",
    jzdesc2:
      "看空净值=上个调整时点的净值*[1-3*(现货最新成交价-现货上个调整时点价格)/现货上个调整时点价格*100%]；",
    sbd: "三倍多",
    sbs: "三倍少",
    flvjs:
      'ETF资金费率，是平台每日对杠杆收取相应比例的管理费，来支付基金组合产生的资金费率。管理费会体现在净值变化中，即会以"扣除相应杠杆ETF的价值"的方式呈现，且仅在新加坡时间0点收取，如果不在该时间点持有产品即不会产生费用。',
    mzsm: "免责声明",
    ido: "我已阅读并同意",
    exemption1: "尊敬的客户，您好！",
    exemption2:
      "感谢您登陆并使用BiKing平台（BiKing.ai）提供的公干ETF产品和相关服务（以下简称“ETF产品”）。请你仔细阅读ETF产品说明和如下风险提示，您在阅读后继续使用ETF产品，即视为您已经完全了解并理解ETF产品的风险，能够承担使用ETF产品可能带来的损失，并视为您同意本免责声明的全部内容。请点击阅读ETF产品说明：",
    exemption3: "《杠杆ETF产品FAQ》",
    exemption4: "风险提示：",
    exemption5:
      "1.您购买/出售的价格不应该较单位净值有较大的偏差，不然您会蒙受相应的损失。",
    exemption6: "2.如果方向判断错误，在极端行情下会存在价格趋近于归零的风险。",
    exemption7:
      "BiKing平台在此郑重的提醒您，因上述风险导致的损失或责任，均由您自行承担，BiKing平台对此不承担任何责任。本免责声明与BiKing平台内的其他协议、声明、规则等一起，构成BiKing平台与您就BiKing平台的服务和产品所达成的全部合意。",
    bzjs1: "1、“3L”表示标的交易对价格上涨1%，该产品净值上涨3%",
    bzjs2: "2、“3S”表示标的交易对价格下跌1%，该产品净值上涨3%",
    bzjs3: "3、净值正常每天0点进行调整，极端行情会在盘中进行调整",
    bzjs4: "4、每倍杠杆将按天收取相应的管理费用",
    bzjs5:
      "5、交易前请注意查看净值，该产品在极端行情下会存在价格趋近于归零，价格远远偏离净值的风险，请投资者注意控制风险",
    gdjk: "更多详情请查看公告",
    firstTrading: "初次交易前，请先设置交易密码",
    status: "状态",
    status1: "待撮合",
    status2: "未成交",
    status3: "用户撤销",
    status4: "部分成交",
    status5: "完全成交",
    status6: "无效",
    allCancel: "批量撤销全部委单",
    canceld: "撤单",
    cancelsuccess: "全部撤单成功,已撤[*]条委单",
    VIP1: "您的等级VIP",
    VIP2: "更为低廉的交易手续费用，更为优质的交易体验",
    VIP3: "Taker(吃单)：",
    VIP4: "Maker(挂单)：",
    buyAmount: "买入数量不能高于",
    sellAmount: "卖出数量不能高于",
    buyAmountMin: "您的可买余额不足",
    sellAmountMin: "您的可卖余额不足",
}



// WEBPACK FOOTER //
// ./src/i18n/lang/trading1/zh.js